import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { GlobalStyle } from "@swegon/sds-core";

import { SdsSetup, SdsWrapper } from "./Sds";
import ReleaseActivatedContext from "./ahu/ReleaseActivatedContext";

import ApplicationRoutes from "./routes";
import Login from "./pages/Login";
import SignOut from "./pages/SignOut";
import SignedOn from "./pages/SignedOn";
import AuthorizationRoute from "./routes/AuthorizationRoute";

import NoAccess from "./pages/NoAccess";
import Projects from "./pages/Projects";

import { getLocationPath } from "./ahu/lib";

const isAhudRedirect = window.location.pathname.endsWith("ahudLite");
if (isAhudRedirect) {
    const ahudLiteQuery = localStorage.getItem("ahudLiteQuery");
    localStorage.removeItem("ahudLiteQuery");
    window.location.href = `${window.location.origin}/ahu${ahudLiteQuery}`;
}

// If it's the latest version served on /ahu, we base the routes on /ahu.
// Otherwise, if it's served on a specific version (e.g. /1.0.123.456)
// we base it on that, fetching the version number from the config
// Only use basename if the URL actually starts with the computed path
const locationPath = getLocationPath(window.location.pathname);
const basename = locationPath !== "/" && window.location.pathname.startsWith(locationPath) ? locationPath : undefined;

const App = () => (
    <>
        <GlobalStyle />
        <Router basename={basename}>
            <SdsSetup>
                <ReleaseActivatedContext>
                    <div className='App'>
                        <SdsWrapper>
                            <Routes>
                                <Route path='/login' element={<Login />} />
                                <Route path='/signout' element={<SignOut />} />
                                <Route path='/noAcess' element={<NoAccess />} />
                                <Route path='/Forbidden' element={<NoAccess />} />
                                <Route path='/*' element={<AuthorizationRoute><ApplicationRoutes /></AuthorizationRoute>} />
                                <Route path='/projects' element={<AuthorizationRoute><Projects /></AuthorizationRoute>} />
                                <Route path='/authorized' element={<SignedOn />} />
                            </Routes>
                        </SdsWrapper>
                    </div>
                </ReleaseActivatedContext>
            </SdsSetup>
        </Router>
    </>
);
export default App;
